import styled, { injectGlobal } from 'styled-components'

injectGlobal`
  img {
    -webkit-user-select: none !important;
    -webkit-touch-callout: none !important;
  }

  body {
    font-family: 'ABChanel-Regular', Arial, sans-serif;
    margin: 0;
    padding: 0;
    padding-bottom: env(safe-area-inset-bottom);
    list-style-type: none;
  }

  button {
    border-radius: 0 !important;
  }

  .modal-open {
    overflow: hidden;
    position: fixed;
  }

  div[class^="MuiDrawer-paper"] {
    overflow: hidden;
  }

  div[class^="MuiPaper-root"] {
    overflow: hidden;
  }
`

export default styled.div``



// WEBPACK FOOTER //
// ./src/styles/App.js